import React from "react";
import { useTranslation } from "react-i18next";
import { useColors } from "../../constants/Colors";
import StepWrapper from "./StepWrapper";
import { CreateFlatStore } from "../../hooks/useCreateFlatStore";

interface Props {
  store: CreateFlatStore;
}

const QuestionsStep: React.FC<Props> = ({ store }) => {
  const { t } = useTranslation();
  const { textNeutralDefault, textNeutralMuted } = useColors();

  const questionSuggestions = [
    t("question_suggestions.why_moving") ||
      "Why are you looking for a new place?",
    t("question_suggestions.about_yourself") || "Tell us a bit about yourself",
    t("question_suggestions.hobbies") || "What are your hobbies?",
    t("question_suggestions.ideal_roommate") ||
      "What's your ideal roommate like?",
  ];

  return (
    <StepWrapper
      title={
        t("flats_tab.add_flat.flat_question_title") ||
        "Add a screening question"
      }
      subtitle={
        t("flats_tab.add_flat.flat_question_subtitle") ||
        "Applicants will answer this question (optional)"
      }
    >
      <div className="space-y-5">
        <textarea
          value={store.question}
          onChange={(e) => {
            if (e.target.value.length <= 200) {
              store.setQuestion(e.target.value);
            }
          }}
          placeholder={
            t("flats_tab.add_flat.flat_question_placeholder") ||
            "Ask something you'd like to know about applicants..."
          }
          rows={4}
          className="cf-textarea"
          style={{ color: textNeutralDefault }}
        />

        <div>
          <p
            className="text-xs tracking-wide uppercase font-medium mb-3"
            style={{ color: textNeutralMuted }}
          >
            {t("suggestions") || "Suggestions"}
          </p>
          <div className="flex flex-wrap gap-2">
            {questionSuggestions.map((suggestion, index) => (
              <button
                key={index}
                onClick={() => store.setQuestion(suggestion)}
                className="cf-pill text-xs"
                style={{
                  backgroundColor:
                    store.question === suggestion
                      ? "rgba(91, 61, 246, 0.1)"
                      : "rgba(2, 2, 16, 0.05)",
                  color:
                    store.question === suggestion
                      ? "rgba(91, 61, 246, 1)"
                      : textNeutralDefault,
                  borderColor:
                    store.question === suggestion
                      ? "rgba(91, 61, 246, 0.2)"
                      : "rgba(2, 2, 16, 0.08)",
                  padding: "8px 16px",
                }}
              >
                {suggestion}
              </button>
            ))}
          </div>
        </div>
      </div>
    </StepWrapper>
  );
};

export default QuestionsStep;
